<div class="tooltip-host">
  @if(showIcon()){
    <span class="info-icon">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.99935 12.8337C10.221 12.8337 12.8327 10.222 12.8327 7.00033C12.8327 3.77866 10.221 1.16699 6.99935 1.16699C3.77769 1.16699 1.16602 3.77866 1.16602 7.00033C1.16602 10.222 3.77769 12.8337 6.99935 12.8337Z"
          fill="#6B50A5" />
        <path d="M7 4.66699V7.00033" stroke="white" stroke-width="1.3" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M7 9.33301H7.00667" stroke="white" stroke-width="1.3" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </span>
  }

  <div class="tooltip-popup" [class.always-visible]="!showIcon()">
    <ul>
      @for (item of items(); track item) {
        <li class="text-type-nine">{{ item }}</li>
      }
    </ul>
    <div class="tooltip-arrow"></div>
  </div>
</div>
